module.exports = __webpack_public_path__ + "static/media/avatar-butler.b19202c3.png";